module.exports = __webpack_public_path__ + "img/8-4.6e91e23f.png";